// トライアル（簡易ログイン）セッション用の共通ガード
// ------------------------------------------------------------------
// トライアル URL（/trial_account?email=..&key=..）から自動生成・自動ログインされた
// 「簡易ログイン（メール未確認）」セッションでは、サーベイ回答・動画視聴は可能だが
// 結果 PDF のダウンロードとパスワード変更は禁止（サーバー側でも 403 でブロック済み）。
// 本モジュールはその「フロント側の 1 層」を担い、
//   ① 不要な PDF 生成・S3 アップロードを起こさない
//   ② 「メール確認後に再ログイン」を案内してログアウトさせる
// を受け持つ。
import React from 'react';
import { Modal } from 'antd';
import { logoutUser } from '../_actions/user_actions';
import { clearSession } from './sessionGuard';

// 簡易ログイン（メール未確認）セッションかどうか
export function isTrialQuickSession(user) {
  return !!(user && user.userData && user.userData.trialQuickLogin === true);
}

// ログイン画面へ遷移（メールアドレスが分かる場合はプリフィル）
function goToLogin(email) {
  const query = email ? '?email=' + encodeURIComponent(email) : '';
  window.location.replace('/login' + query);
}

// 結果のダウンロードをブロックし、案内後にログアウトしてログイン画面へ送る
// options: { dispatch, email }
export function blockResultForQuickSession(options) {
  const opts = options || {};
  const dispatch = opts.dispatch;
  const email = opts.email;

  Modal.info({
    title: 'メールをご確認ください',
    content: (
      <span>
        結果のダウンロードには、メールでお送りしたログイン情報での再ログインが必要です。
        <br />
        メールに記載のパスワードでログインしてから、改めて結果をご確認ください。
      </span>
    ),
    okText: 'ログイン画面へ',
    onOk() {
      // サーバー側のセッションも確実に切ってからログイン画面へ。
      // ログアウト API が失敗しても画面遷移は必ず行う。
      try {
        if (dispatch) {
          dispatch(logoutUser())
            .then(() => {
              clearSession();
              goToLogin(email);
            })
            .catch(() => {
              clearSession();
              goToLogin(email);
            });
          return;
        }
      } catch (e) {
        // 何らかの理由で dispatch に失敗した場合もログイン画面へ送る
      }
      clearSession();
      goToLogin(email);
    },
  });
}
